import { DatePipe, DecimalPipe } from '@angular/common';
import {
  Component,
  effect,
  inject,
  input,
  signal,
  untracked,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from '@core/auth/auth.service';
import { CprNummerPipe } from '@core/pipes/cprnummer.pipe';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { LetsikringRevision } from '@features/letregister/letsikring-revision.model';
import { LetsikringApi } from '@features/letregister/letsikring.api';
import { Letsikring } from '@features/letregister/letsikring.model';
import { RisikoOpkraevningStatus } from '@features/risikoopkraevning/risiko-opkraevning-status.model';
import { RisikoOpkraevning } from '@features/risikoopkraevning/risiko-opkraevning.model';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { ScrollPanel } from 'primeng/scrollpanel';
import { TableModule } from 'primeng/table';
import { LetsikringRevisionComponent } from '../../../letregister/letregister-detail/letsikring-revision/letsikring-revision.component';
import { RisikoOpkraevningDatasource } from '../risiko-opkraevning.datasource';

@Component({
  selector: 'app-risiko-opkraevning-detail',
  imports: [
    TableModule,
    TableRowDirective,
    CprNummerPipe,
    DatePipe,
    DecimalPipe,
    ScrollPanel,
    Dialog,
    Button,
    LetsikringRevisionComponent,
  ],
  templateUrl: './risiko-opkraevning-detail.component.html',
  styleUrl: './risiko-opkraevning-detail.component.css',
})
export class RisikoOpkraevningDetailComponent {
  datasource = inject(RisikoOpkraevningDatasource);
  risikoOpkraevning = input.required<RisikoOpkraevning>();
  authService = inject(AuthService);
  letsikringApi = inject(LetsikringApi);
  showHistorik = signal(false);
  showRevision = signal(false);
  selectedLetsikring = signal<Letsikring | undefined>(undefined);
  selectedRevision = signal<LetsikringRevision | undefined>(undefined);
  forloeb = signal<RisikoOpkraevningStatus[]>([]);
  historik = signal<RisikoOpkraevning[]>([]);

  form = new FormGroup({});

  constructor() {
    effect(async () => {
      untracked(async () => {
        const forloeb = await this.datasource.getForloeb(
          this.risikoOpkraevning().id!
        );
        this.forloeb.set(forloeb);
      });
    });

    effect(async () => {
      if (this.risikoOpkraevning().letsikringNr) {
        untracked(async () => {
          const historik = await this.datasource.getHistorik(
            this.risikoOpkraevning().letsikringNr!
          );
          this.historik.set(historik);
        });
      }
    });
  }

  async visRevisionDetaljer() {
    const opkraevning = this.risikoOpkraevning();
    if (opkraevning) {
      const letsikring = await this.letsikringApi.getById(
        opkraevning.letsikringId!
      );
      if (letsikring) {
        this.selectedLetsikring.set(letsikring);

        const revision = letsikring.revisioner.find(
          x => x.id === opkraevning.letsikringRevisionId
        );
        this.selectedRevision.set(revision);

        this.showRevision.set(true);
      }
    }
  }
}
